import { render, staticRenderFns } from "./StatsSelection.vue?vue&type=template&id=5ace600e"
import script from "./StatsSelection.vue?vue&type=script&lang=js"
export * from "./StatsSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports